var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImportante(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "22px",
    viewBox: "0 0 18 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "notification_important") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rounded",
    transform: "translate(-137.000000, -729.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Alert",
    transform: "translate(100.000000, 674.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "-Round-/-Alert-/-notification_important",
    transform: "translate(34.000000, 54.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-29",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12,23 C13.1,23 13.99,22.11 13.99,21.01 L10.01,21.01 C10.01,22.11 10.9,23 12,23 Z M20.29,18.29 L19,17 L19,11 C19,7.65 16.64,4.85 13.5,4.17 L13.5,3 C13.5,2.17 12.83,1.5 12,1.5 C11.17,1.5 10.5,2.17 10.5,3 L10.5,4.17 C7.36,4.85 5,7.65 5,11 L5,17 L3.71,18.29 C3.08,18.92 3.52,20 4.41,20 L19.58,20 C20.48,20 20.92,18.92 20.29,18.29 Z M13,16 L11,16 L11,14 L13,14 L13,16 Z M13,11 C13,11.55 12.55,12 12,12 C11.45,12 11,11.55 11,11 L11,9 C11,8.45 11.45,8 12,8 C12.55,8 13,8.45 13,9 L13,11 Z",
    id: "\\uD83D\\uDD39Icon-Color"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportante);
export default __webpack_public_path__ + "static/media/importante.965e470427174debab2ba87e71f79b2c.svg";
export { ForwardRef as ReactComponent };